import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// you will also need the css that comes with bootstrap-daterangepicker
import { TextField } from '@mui/material';
import { IoCalendarOutline } from 'react-icons/io5';
import momentZ from 'moment';
import BlockIcon from '@assets/jsx-icon/BlockIcon';
var momentTimeZone = require('moment-timezone');
momentTimeZone.tz.setDefault('UTC');

export interface DateRangeValue {
    startDate?: Date;
    endDate?: Date;
}

type Props = {
    value: DateRangeValue;
    onChange?(value: DateRangeValue): void;
    initialSettings?: any;
    label?: string;
    dateReset?: DateRangeValue;
    disableLoading?: boolean;
    placeholder?: string;
    disableFutureDates?: boolean;
};

const moment = (inp?: momentZ.MomentInput) => {
    return momentZ(inp).utcOffset(0);
};

const RESET_OPTION = 'All dates';

export default function StyledDateRangePicker(props: Props) {
    const [dateRange, setDateRange] = useState(props.value);
    const value =
        !dateRange?.startDate || !dateRange.endDate
            ? ''
            : moment(dateRange.startDate).format('DD/MM/YYYY') + ' ~ ' + moment(dateRange.endDate).format('DD/MM/YYYY');

    const keyRef = useRef(Date.now());
    const handleChangeRanges = () => {
        keyRef.current = Date.now();
    };

    useEffect(() => {
        setDateRange(props.value);
        handleChangeRanges();
    }, [props.value]);

    return (
        <DateRangePicker
            key={keyRef.current}
            initialSettings={{
                autoApply: true,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 days': [moment().subtract(29, 'days'), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')],
                    'Last month': [
                        moment().subtract(1, 'month').startOf('month'),
                        moment().subtract(1, 'month').endOf('month'),
                    ],
                    'All dates': [props.dateReset?.startDate ?? undefined, props.dateReset?.endDate ?? undefined],
                },
                alwaysShowCalendars: true,
                startDate: dateRange?.startDate ?? undefined,
                endDate: dateRange?.endDate ?? undefined,
                maxDate: props.disableFutureDates ? moment().endOf('day') : undefined,
                opens: 'left',
                ...props.initialSettings,
            }}
            onApply={(e, date) => {
                const isSelectResetDate = date.chosenLabel === RESET_OPTION;
                const { startDate, endDate } = date;
                const start = isSelectResetDate ? props.dateReset?.startDate ?? undefined : startDate.toDate();
                const end = isSelectResetDate ? props.dateReset?.endDate ?? undefined : endDate.toDate();
                console.log('onApply');
                setDateRange({ startDate: start, endDate: end });
                props.onChange?.({ startDate: start, endDate: end });
            }}
        >
            <TextField
                label={props.label ?? 'Permit date'}
                placeholder={props.placeholder || 'Select date range'}
                disabled={props.disableLoading}
                value={value}
                InputProps={
                    props.disableLoading
                        ? undefined
                        : {
                              readOnly: true,
                              endAdornment: <BlockIcon width={24} height={24} color="gray" />,
                          }
                }
                fullWidth
                sx={{
                    '& *': {
                        cursor: props.disableLoading ? 'default' : 'pointer',
                    },
                    display: 'flex',
                    justifyContent: 'center',
                }}
            />
        </DateRangePicker>
    );
}
